import { useEffect, useRef } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import KineticHero from "@/components/KineticHero";
import EditorialMarquee from "@/components/EditorialMarquee";
import ProcessManifesto from "@/components/ProcessManifesto";
import ServicesBento from "@/components/ServicesBento";
import TrustSection from "@/components/TrustSection";
import CoverageArea from "@/components/CoverageArea";
import FaqSection from "@/components/FaqSection";
import QuoteForm from "@/components/QuoteForm";
import IndustrialFooter from "@/components/IndustrialFooter";
import TownPage from "@/components/TownPage";

export const scrollTo = (target) => {
    if (target !== 0 && !document.querySelector(target)) {
        window.location.href = `/${target}`;
        return;
    }
    if (window.__lenis) {
        window.__lenis.scrollTo(target, { offset: -64, duration: 1.4 });
    }
};

function App() {
    const lenisRef = useRef(null);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09 });
        lenisRef.current = lenis;
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App bg-tarmac text-paper">
            <Toaster theme="dark" position="bottom-right" />
            <BrowserRouter>
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/areas/:slug" element={<TownPage />} />
                </Routes>
                <IndustrialFooter />
            </BrowserRouter>
        </div>
    );
}

function Home() {
    useEffect(() => {
        if (window.location.hash) {
            const t = setTimeout(
                () => window.__lenis?.scrollTo(window.location.hash, { offset: -64 }),
                700
            );
            return () => clearTimeout(t);
        }
    }, []);

    return (
        <main>
            <KineticHero />
            <EditorialMarquee />
            <ProcessManifesto />
            <ServicesBento />
            <TrustSection />
            <CoverageArea />
            <FaqSection />
            <QuoteForm />
        </main>
    );
}

export default App;
